import React, { useContext } from 'react'
import {AbbreviationsContext} from "../context/AbbreviationProvider";

const useAbbreviations = () => {
    return useContext(AbbreviationsContext)
}

export default useAbbreviations
